<template>
  <div class="jidudatepicker">
    <span>
      <mark
        style="position: fixed; top: 0; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0); z-index: 999"
        v-show="showSeason"
        @click.stop="showSeason = false"
      ></mark>
      <el-input :placeholder="$t('finance.select-quarter')" v-model="showValue" @focus="showSeason = true">
        <i slot="prefix" class="el-input__icon el-icon-date"></i>
      </el-input>
      <el-card
        class="box-card"
        style="width: 322px; padding: 0 3px 20px; margin-top: 10px; position: fixed; z-index: 9999"
        v-show="showSeason"
      >
        <div slot="header" class="firstBtn">
          <button
            type="button"
            :aria-label="$t('v216_6.previous-year')"
            class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
            @click="prev"
          ></button>
          <span role="button" class="el-date-picker__header-label">{{ year + $t("v210831.year") }}</span>
          <button
            type="button"
            :aria-label="$t('v216_6.the-following-year')"
            @click="next"
            class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
          ></button>
        </div>
        <div class="text container">
          <el-button
            :type="season == 1 ? 'primary' : 'text'"
            size="medium"
            style="width: 47%; float: left"
            @click="selectSeason(1)"
            >{{ $t("finance.first-quarter") }}</el-button
          >
          <el-button
            :type="season == 2 ? 'primary' : 'text'"
            size="medium"
            style="float: right; width: 47%"
            @click="selectSeason(2)"
            >{{ $t("finance.second-quarter") }}</el-button
          >
        </div>
        <div class="item container" style="text-align: center">
          <el-button
            :type="season == 3 ? 'primary' : 'text'"
            size="medium"
            style="width: 47%; float: left"
            @click="selectSeason(3)"
            >{{ $t("finance.third-quarter") }}</el-button
          >
          <el-button
            :type="season == 4 ? 'primary' : 'text'"
            size="medium"
            style="float: right; width: 47%"
            @click="selectSeason(4)"
            >{{ $t("finance.fourth-quarter") }}</el-button
          >
        </div>
      </el-card>
    </span>
  </div>
</template>

<script>
/**
 * @file:  View 组件 季节选择控件
 * @description: UI组件  可选择季节
 */
export default {
  name: "jududatepicker",
  props: {
    valueArr: {
      default: () => {
        return ["01-03", "04-06", "07-09", "10-12"];
      },
      type: Array
    },
    getValue: {
      default: val => {
        return val;
      },
      type: Function
    }
  },
  data() {
    return {
      showSeason: false,
      season: "",
      year: new Date().getFullYear(), // input显示时间，会随着用户操作改变
      defaultyear: new Date().getFullYear(), // 当前年份，不变
      month: new Date().getMonth() + 1, // 当前月份，不变
      showValue: "",
      beforeyear: null // 默认显示上一季度所用时间，可能是去年
    };
  },

  mounted() {
    // 每次挂在时都对组件进行重置，那么就不需要在上级组件中进行重置
    this.getDefaultTime();
  },

  methods: {
    one() {
      this.showSeason = false;
    },
    prev() {
      this.year = this.year * 1 - 1;
    },
    next() {
      this.year = this.year * 1 + 1;
    },
    selectSeason(i) {
      let that = this;
      this.season = i;
      that.showSeason = false;
      this.showValue = `${this.year}Q${this.season}`;
      that.$emit("chooseSeason", this.showValue); // 每次选择时间都将当前选择时间发送到父组件
    },
    reset() {
      // 季度重置 上一季度
      this.getDefaultTime();
    },
    getDefaultTime() {
      // 获取默认的上一个季度
      var year = this.defaultyear;
      var month = this.month;
      if (month <= 3) {
        this.season = 1;
      } else if (month > 3 && month <= 6) {
        this.season = 2;
      } else if (month > 6 && month <= 9) {
        this.season = 3;
      } else if (month > 9 && month <= 12) {
        this.season = 4;
      }
      this.showValue = `${year}Q${this.season}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.jidudatepicker {
  flex: 1;
  margin-left: 20px;
  .firstBtn {
    height: 30px;
    line-height: 34px;
    width: 100%;
    text-align: center;
  }
  .text {
    text-align: center;
  }
  .item {
    text-align: center;
  }
  .el-button {
    background: #fff;
    color: #606266;
  }
  .el-button--primary {
    color: #fff;
    background-color: #ffcf00;
    border-color: #ffcf00;
  }
}
.colorDis {
  color: #999 !important;
}
</style>
<style lang="scss">
.jidudatepicker {
  .el-card__header {
    padding: 12px;
  }
}
</style>
